<template>
  <router-view />
  <v-container  fluid class="fill-height back">
    <v-row class="rowlogin">
      <v-col class="d-flex justify-center">
        <v-img
            :src="require('../assets/LogoApp.png')"

            contain
            height="200"
        />

      </v-col>
      <v-divider class="noneshow"/>
      <v-sheet class="mx-auto login" >
        <div id="login">
          <h3 class="text-center">ورود به پنل کاربری</h3>
          <div class="form-group">
            <div class="col-sm-12">
              <label class="label">
                نام کاربری :
              </label>
              <input id="mobile-field" style="direction: ltr !important;" required v-model="mobile" type="text" class="form-control text-center" name="mobile" placeholder="نام کاربری خود را وارد کنید">

            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12">
              <label class="label">
                کلمه عبور :
              </label>
              <input id="mobile-field" style="direction: ltr !important;" required v-model="password" type="password" class="form-control text-center" name="password" placeholder="رمز خود را وارد کنید">

            </div>
          </div>
          <div class="text-center">
            <button class="btn btn-success"  type="button" @click="login">ورود</button>
          </div>
        </div>
      </v-sheet>
    </v-row>

  </v-container>
</template>

<script >
import http from "@/plugins/axios";
import {th} from "vuetify/locale";
import router from "@/router";
export default {
  name: 'login',

  data: () => ({
    islogin : false,
    check : false,
    mobile : "",
    password : "",
    auth : {
      token: "",
      user :{
        name : "",
        phone : "",
        profile : "",
      }
    }
  }),
  methods:{
     login(){
       if(this.check){

       }else{
         this.check = true;
         const response =http.post("/getToken.php",{
           mobile : this.mobile,
           password : this.password
         }).then(response => {
           this.auth.token = response.data.token;
           localStorage.setItem("token",this.auth.token);
           router.push("/home");
           this.$toast.success("با موفقیت وارد حساب کاربری خود شدید.");

         }).catch((error) => {
           this.$toast.error("خطا در حین ورود به حساب کاربری");
           this.check = false;
         });


       }
     },
    checkLogin(){
      this.auth.token = localStorage.getItem("token");
      if(this.auth.token !=null){
        router.push("/home");
      }
    }
  },
  mounted() {
    this.checkLogin();
  },
}
</script>



<style scoped>
.fill-height{
  width: 100%;
  max-width: 100%;
}
v-sheet{
  background: transparent;
}
  .form-group{
    margin: 10px auto;
    width: 100%;
  }
  .form-group input{
    padding: 10px;
    width: 100%;
  }
.form-group .label{
  margin: 10px 0;
}
button.btn{
  width: 400px;
  max-width: 90%;
  padding: 10px;
  margin: 10px auto;
}
  .back{
    background-color: #e8e8e8;
    background-image: url('../assets/newback1.png');
    background-repeat: repeat;
    background-size: cover;
  }
  #login{
    background: transparent;
  }
  #login .form-inputs {
    padding-bottom: 10px;
  }

  #login .form-inputs label {
    padding-right: 10px;
  }
  .loading{
    position: absolute;
    top: 65%;
    left: 49%;
  }
  .mx-auto{
    direction: rtl;
    background: transparent;
  }
  .v-field--center-affix .v-label.v-field-label{
    right: 0;
  }
  .noneshow{
    opacity: 0;
  }
  #login h3{
    margin: 20px auto;
  }
  .login{
    max-width: 100%;
    width: 500px;
    padding: 0 10px;
  }
.rowlogin {
  width: 100%;
}
</style>